import { action, makeAutoObservable, observable } from 'mobx';
import { MapCollection } from '@dirootie-extensions/javascript-collections';
import { SingleOrArray } from '@dirootie-extensions/typescript';
import { singleOrArrayToArray } from '@dirootie-extensions/javascript';
import { ILogger } from '@dirootie-logging/logging-types';

export class MainAppViewStore {
  @observable loading = false;

  private _viewProvider: MapCollection<string, any> = new MapCollection(
    (x) => x.id
  );

  private _currentViewId: string | undefined = undefined;

  get currentViewId() {
    return this._currentViewId;
  }

  set currentViewId(value: string | undefined) {
    this.logger.trace(
      `[userInterfaceState:hook]: Changed view. Views(previous -> current): ('${this._currentViewId}' -> '${value}').`
    );
    this._currentViewId = value;
  }

  registerView(views: SingleOrArray<any>) {
    this._viewProvider.addRange(singleOrArrayToArray(views));
  }

  getView(viewId: string) {
    return this._viewProvider.get(viewId);
  }

  constructor(private logger: ILogger) {
    makeAutoObservable(this);
  }

  get isLoading() {
    return this.loading;
  }

  @action
  startLoading() {
    this.loading = false;
  }

  @action
  stopLoading() {
    this.loading = false;
  }
}
